import cx from 'classnames';

import { Box } from '@evaneos/b2b-ui';
import CloseIcon from '@evaneos/b2b-ui/icons/Close';

import { MessageAttachment } from '../../../../../resources/discussion/types';

import s from './NewMessageBox.css';

type Props = {
    attachment: MessageAttachment;
    onDeleteAttachment: (attachment: MessageAttachment) => void;
};

// Similar component to Attachment.tsx, but much simpler, to be used in the EditMessageBox, for displaying existing attachments and allow for their deletion
export const AttachmentViewAndDelete = ({ attachment, onDeleteAttachment }: Props) => {
    const { name, type } = attachment;

    return (
        <Box
            key={name}
            className={cx(s.attachment)}
            sx={{ cursor: 'default' }}
            data-testid="nmb-attachment"
        >
            <div className={s.type}>{type}</div>
            <p>{name}</p>
            <a className={cx(s.attachmentIcon)} onClick={() => onDeleteAttachment(attachment)}>
                <CloseIcon sx={{ color: 'icon.primary', width: '24px', height: '24px' }} />
            </a>
        </Box>
    );
};
